
const GUARD_COOKIE = "_zenvoya_dead_session_cleared";
const GUARD_WINDOW_SECONDS = 60;

const recentlyCleared = (): boolean => {
  try {
    return document.cookie.split(";").some((c) => c.trim() === `${GUARD_COOKIE}=1`);
  } catch {
    return false;
  }
};

export function recoverDeadSession(signOutInPlace: () => void): void {
  if (recentlyCleared()) {
    console.warn("[auth] logged-in session with no usable token recurred after a clear — signing out in place");
    signOutInPlace();
    return;
  }
  try {
    document.cookie = `${GUARD_COOKIE}=1; path=/; max-age=${GUARD_WINDOW_SECONDS}; SameSite=Lax`;
  } catch {
    signOutInPlace();
    return;
  }
  if (!recentlyCleared()) {
    signOutInPlace();
    return;
  }
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch {
  }
  console.log("[auth] logged-in session with no usable token — storage cleared, reloading");
  window.location.reload();
}
